import ConveyorsGamePlugin from 'app/src/plugins/ConveyorsGamePlugin';
import EmptyFloorGamePlugin from 'app/src/plugins/EmptyFloorGamePlugin';
import GamePlugin from 'app/src/plugins/GamePlugin';
import GearsGamePlugin from 'app/src/plugins/GearsGamePlugin';
import PitsGamePlugin from 'app/src/plugins/PitsGamePlugin';
import RobotsGamePlugin from 'app/src/plugins/RobotsGamePlugin';

export enum GameLoaderError {
	UnsupportedPlugin,
}

export default class GamePluginLoader {
	public static sharedInstance = new GamePluginLoader();

	private _loadedPlugins: { [key: string]: GamePlugin } = {};

	public loadPlugin(pluginName: string): GamePlugin {
		if (this._loadedPlugins[pluginName]) {
			return this._loadedPlugins[pluginName];
		}

		let plugin: GamePlugin | null;

		// Check to see if we support this plugin. This is where new plugins
		// get added to the list.
		switch (pluginName) {
			case 'EmptyFloorGamePlugin':
				plugin = new EmptyFloorGamePlugin();
				break;
			case 'ConveyorsGamePlugin':
				plugin = new ConveyorsGamePlugin();
				break;
			case 'PitsGamePlugin':
				plugin = new PitsGamePlugin();
				break;
			case 'GearsGamePlugin':
				plugin = new GearsGamePlugin();
				break;
			case 'RobotsGamePlugin':
				plugin = new RobotsGamePlugin();
				break;
			default:
				plugin = null;
		}

		// Error if we don't.
		if (plugin === null) {
			throw GameLoaderError.UnsupportedPlugin;
		}

		// Save the new instance.
		this._loadedPlugins[pluginName] = plugin;

		// Return the new instance.
		return plugin;
	}

	public unloadAllPlugins(): void {
		this._loadedPlugins = {};
	}

	public unloadPlugin(pluginName: string): void {
		delete this._loadedPlugins[pluginName];
	}
}
